import Vue from 'vue';
import PrimeVue from 'primevue/config';
import PrimeVueOptions from './prime-vue-options';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';

import Toast from 'primevue/toast';
import DataTable from 'primevue/datatable';
import Toolbar from 'primevue/toolbar';
import FileUpload from 'primevue/fileupload';
import RadioButton from 'primevue/radiobutton';
import Dropdown from 'primevue/dropdown';
import InputNumber from 'primevue/inputnumber';
import Textarea from 'primevue/textarea';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import SelectButton from 'primevue/selectbutton';
import Card from 'primevue/card';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import SplitButton from 'primevue/splitbutton';
import MegaMenu from 'primevue/megamenu';
import ScrollPanel from 'primevue/scrollpanel';
import Avatar from 'primevue/avatar';
import ConfirmDialog from 'primevue/confirmdialog';
import Calendar from 'primevue/calendar';
import Breadcrumb from 'primevue/breadcrumb';
import ColumnGroup from 'primevue/columngroup';
import Row from 'primevue/row';
import Panel from 'primevue/panel';
import Divider from 'primevue/divider';
import Chip from 'primevue/chip';
import Tooltip from 'primevue/tooltip';
import Tag from 'primevue/tag';
import Galleria from 'primevue/galleria';
import ImagePreview from 'primevue/imagepreview';
import FullCalendar from 'primevue/fullcalendar';
import InputSwitch from 'primevue/inputswitch';
import ProgressBar from 'primevue/progressbar';
import Fieldset from 'primevue/fieldset';
import ColorPicker from 'primevue/colorpicker';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import SpeedDial from 'primevue/speeddial';
import TieredMenu from 'primevue/tieredmenu';
import Checkbox from 'primevue/checkbox';

import 'primevue/resources/themes/saga-blue/theme.css';
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

Vue.use(PrimeVue, PrimeVueOptions);
Vue.use(ToastService);
Vue.use(ConfirmationService);

// components
Vue.component('DataTable', DataTable);
Vue.component('Column', Column);
Vue.component('InputText', InputText);
Vue.component('InputNumber', InputNumber);
Vue.component("InputSwitch", InputSwitch);
Vue.component('SelectButton', SelectButton);
Vue.component('Toolbar', Toolbar);
Vue.component('ImagePreview', ImagePreview);
Vue.component('FileUpload', FileUpload);
Vue.component('RadioButton', RadioButton);
Vue.component('FullCalendar', FullCalendar);
Vue.component('Dropdown', Dropdown);
Vue.component('Button', Button);
Vue.component('Dialog', Dialog);
Vue.component('SpeedDial', SpeedDial);
Vue.component('Textarea', Textarea);
Vue.component('Toast', Toast);
Vue.component('Card', Card);
Vue.component('Accordion', Accordion);
Vue.component('AccordionTab', AccordionTab);
Vue.component('SplitButton', SplitButton);
Vue.component('MegaMenu', MegaMenu);
Vue.component('Galleria', Galleria);
Vue.component('ScrollPanel', ScrollPanel);
Vue.component('AvatarPrime', Avatar);
Vue.component("ConfirmDialog", ConfirmDialog);
Vue.component("Calendar", Calendar);
Vue.component("Breadcrumb", Breadcrumb);
Vue.component("ColumnGroup", ColumnGroup);
Vue.component("Row", Row);
Vue.component("Panel", Panel);
Vue.component("Divider", Divider);
Vue.component("Tag", Tag);
Vue.component("Chip", Chip);
Vue.component("Fieldset", Fieldset);
Vue.component("ProgressBar", ProgressBar);
Vue.component("ColorPicker", ColorPicker);
Vue.component("TabView", TabView);
Vue.component("TabPanel", TabPanel);
Vue.component("TieredMenu", TieredMenu);
Vue.component("Checkbox", Checkbox);
// directives
Vue.directive("Tooltip", Tooltip);



// WEBPACK FOOTER //
// ./src/plugins/prime-vue.js